import { getActionStatusName } from '@/store/helpers';
import {
  GET_NUMBER_ORDERS,
  GET_NUMBER_ORDER,
  CREATE_NUMBER,
  EDIT_NUMBER,
  CREATE_NUMBER_ORDER,
  EDIT_NUMBER_POOL,
  GROW_NUMBER_POOL,
  CREATE_NUMBER_POOL,
  SHRINK_NUMBER_POOL,
  GET_USER_VISIBLE_COLUMNS,
  GET_NUMBER_POOLS, 
  GET_NUMBER_POOL,
  GET_NUMBER_POOL_REFERENCES,
  UPDATE_NUMBER_POOL, 
  DELETE_NUMBER_POOL, 
  GET_NUMBER_AVAILABLE_COUNTRIES
} from './actionTypes';

export const pendingOrdersAmount = state => state.pendingOrders.length;

export const getSelectedOrderStatus = state => state.status[getActionStatusName(GET_NUMBER_ORDER)] || {};
export const getOrdersStatus = state => state.status[getActionStatusName(GET_NUMBER_ORDERS)] || {};

export const createNumberStatus = state => state.status[getActionStatusName(CREATE_NUMBER)] || {};
export const createNumberOrderStatus = state => state.status[getActionStatusName(CREATE_NUMBER_ORDER)] || {};
export const editNumberStatus = state => state.status[getActionStatusName(EDIT_NUMBER)] || {};
export const editNumberPoolStatus = state => state.status[getActionStatusName(EDIT_NUMBER_POOL)] || {};
export const growNumberPoolStatus = state => state.status[getActionStatusName(GROW_NUMBER_POOL)] || {};
export const createNumberPoolStatus = state => state.status[getActionStatusName(CREATE_NUMBER_POOL)] || {};
export const shrinkNumberPoolStatus = state => state.status[getActionStatusName(SHRINK_NUMBER_POOL)] || {};
export const getNumberPoolsStatus = state => state.status[getActionStatusName(GET_NUMBER_POOLS)] || {};  
export const getNumberPoolStatus = state => state.status[getActionStatusName(GET_NUMBER_POOL)] || {};   
export const getUserVisibleColumnsStatus = state => state.status[getActionStatusName(GET_USER_VISIBLE_COLUMNS)] || {};
export const getNumberAvailableCountriesStatus = state => state.status[getActionStatusName(GET_NUMBER_AVAILABLE_COUNTRIES)] || {};

export const getNumberPoolReferencesStatus = state => state.status[getActionStatusName(GET_NUMBER_POOL_REFERENCES)] || {};

export const updateNumberPoolStatus = state => state.status[getActionStatusName(UPDATE_NUMBER_POOL)] || {};
export const deleteNumberPoolStatus = state => state.status[getActionStatusName(DELETE_NUMBER_POOL)] || {};

export const getDisplayNumberPools = (state, getters) => {
  if (getters.isFetchingNumberPools) {
    return [];
  }
  return state.numberPools;
};


